<template>
    <div class="company_box">
        <v-header></v-header>
        <div class="mbx">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/' }" alt="小查线索">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a :href="'/company_check?text='+textStr" alt="查备案">查备案</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <query-list @queryType="upData"></query-list>
        <div class="danwei_list">
            <div class="danwei_list_title">
                搜索到企业数据：<span class="red">{{total}}</span>条
            </div>
            <div class="danwei_list_table">
                <el-table :data="tableData" border style="width: 100%" :header-cell-style="{
                    background:'#F5F7FA',
                    color:'#333333'}">
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="entName" label="主办单位名称"></el-table-column>
                    <el-table-column prop="date" label="工商信息" width="230px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.corpType != 2 && scope.row.clueCorpStatus!='' &&scope.row.clueFoundDate!='' &&scope.row.clueRegCapital!=''">
                                <p>企业状态：{{isNull(scope.row.clueCorpStatus)}}</p>
                                <p>成立日期：{{isNull(scope.row.clueFoundDate)}}</p>
                                <p>注册资本：{{isNull(scope.row.clueRegCapital)}}</p>
                            </div>
                            <div v-else-if="scope.row.corpType != 2">
                                <p v-if="scope.row.clueCorpStatus != ''">企业状态：{{isNull(scope.row.clueCorpStatus)}}</p>
                                <p v-if="scope.row.clueFoundDate != ''">成立日期：{{isNull(scope.row.clueFoundDate)}}</p>
                                <p v-if="scope.row.clueRegCapital != ''">注册资本：{{isNull(scope.row.clueRegCapital)}}</p>
                            </div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="联系方式">
                        <template slot-scope="scope">
                            <div v-if="scope.row.corpType != 2">
                                <p>企业负责人：{{isNull(scope.row.clueLegalPerson)}}</p>
                                <p v-if="scope.row.cluePhone != ''">电话：{{isNull(scope.row.cluePhone)}}<span v-if="scope.row.eCount != 0">({{scope.row.eCount}})</span></p>
                                <p v-if="scope.row.clueEmail != 0">邮箱：({{scope.row.clueEmail}})</p>
                            </div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="网站名称/网址">
                        <template slot-scope="scope">
                            <p v-for="(item,index) in scope.row.webs" :key="index">
                                <span v-if="index == 0">{{item}}</span>
                                <a v-else :href="'//'+item" target="_blank">{{item}}</a>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateDate" label="更新时间" width="90px"></el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="upDataFn.num"
                        :page-size="10"
                        layout="total,prev,pager,next,jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <div style="width:100%;height:20px"></div>
        <v-footer></v-footer>
        <el-dialog :title="windowTitle" :visible.sync="windowType" width="600px" :before-close="handleClose">
            <div class="win_table_box">
                <div class="title-dom-div">
                    <span>ICP备案主体信息</span>
                </div>
                <el-descriptions class="margin-top" :column="2" size="small" border>
                    <el-descriptions-item label-class-name="my-label">
                        <template slot="label">
                            备案/许可证号：
                        </template>
                        新ICP备2022000029号
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label">
                        <template slot="label">
                            审核通过日期：
                        </template>
                        2022-01-07
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label">
                        <template slot="label">
                            主办单位名称：
                        </template>
                        新疆绿珠九鼎农产品经营管理有限公司
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label">
                        <template slot="label">
                            主办单位性质：
                        </template>
                        企业
                    </el-descriptions-item>
                </el-descriptions>
                <div class="title-dom-div">
                    <span>ICP备案网站信息</span>
                </div>
                
                <el-descriptions class="margin-top" :column="2" size="small" border>
                    <el-descriptions-item label-class-name="my-label">
                        <template slot="label">
                            网站名称：	
                        </template>
                        新疆绿珠九鼎农产品经营管理有限公司
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label">
                        <template slot="label">
                            网站备案/许可证号：
                        </template>
                        新ICP备2022000029号-1
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label">
                        <template slot="label">
                            网站首页地址：	
                        </template>
                        www.xjshzjd.com
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label">
                        <template slot="label">
                            网站域名：
                        </template>
                        xjshzjd.com
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label">
                        <template slot="label">
                            网站前置审批项：	
                        </template>
                    </el-descriptions-item>
                    <!-- <el-descriptions-item>
                        <template slot="label">
                        </template>
                    </el-descriptions-item> -->
                </el-descriptions>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import vHeader from './common/header.vue';
import vFooter from './common/footer.vue';
import queryList from './modular/querylist2.vue';
export default {
    data(){
        return{
            windowType:false,
            windowTitle:'',
            textStr:'',
            total:0,
            currentPage1:1,
            tableData:[],
            upDataFn:{
                pro:'',
                key:'',
                type:0,
                promote:0,
                tel:0,
                phone:0,
                email:0,
                num:1,
                state:0
            }
        }
    },
    components:{
        vHeader,
        vFooter,
        queryList
    },
    methods:{
        isNull(a){
            var cc = a == ""? '-':a;
            return cc
        },
        upData(data){
            console.log(data);
            this.upDataFn = data;
            this.upDataFn.pro = data.pro == '全部'? '':data.pro;
            this.upDataFn.num = 1;
            this.queryFun();
        },
        queryFun(){
            var _this = this;
            this.postRequest('api/clue/icp',this.upDataFn).then(res=>{
                var data = _this.$Decrypt(res.data,res.config.headers.time);
                if (data.status == 200) {
                    _this.tableData = data.obj.content;
                    console.log(data.obj.content);
                    _this.total = data.obj.totalElements;
                }
            })
        },
        handleClose(){
            this.windowType = false;
        },
        openWin(row){
            this.windowTitle = "提示"
            this.windowType = true;
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.upDataFn.num = parseInt(val);
            this.queryFun();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.upDataFn.num = parseInt(val);
            this.queryFun();
        }
    },
    mounted(){
        this.upDataFn.key = this.$route.query.text;
        this.queryFun();
    }
}
</script>
<style>
body {
    background-color: #F0F2F5;
}

.my-label{
    background-color: #c9dfef !important;
    color: #606266 !important;
}
</style>
<style lang="scss" scoped>
.company_box{
    width: 100%;
    height: auto;
    background-color: #F0F2F5;
}

.mbx{
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    cursor: default;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    a{
        cursor: default !important;
    }
}

.danwei_list{
    height: auto;
    padding-bottom: 20px;
    @media screen and (max-width: 1400px){
        width: 960px;
        margin: 20px auto 0;
        background-color: #fff;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
        margin: 20px auto 0;
        background-color: #fff;
    }
    >div.danwei_list_title{
        width: 100%;
        height: 68px;
        line-height: 68px;
        padding-left: 34px;
        box-sizing: border-box;
        font-size: 22px;
        font-weight: 500;
        border-bottom: 2px solid #F6F7FB;
        cursor: default;
        >span.red{
            color: #FF0000;
        }
    }
    >div.danwei_list_table{
        width: 100%;
        height: auto;
        padding: 30px 30px 0;
        cursor: default;
        box-sizing: border-box;
        >div.pagination{
            width: 100%;
            height: 40px;
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
        }
    }
}

.win_table_box{
    width: 94%;
    height: auto;
    margin: 0 auto;
    cursor: default;
    >div.title-dom-div{
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        border-bottom: 1px solid #c9dfef;
        margin-bottom: 20px;
        >span{
            width: auto;
            height: 40px;
            line-height: 40px;
            display: inline-block;
            font-weight: bold;
            // padding-bottom: 0.5em;
            border-bottom: #008cff 1px solid;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/company_check.vue